(() => {
  const init = (root) => {
    const dialog = root.querySelector('[data-filter-dialog]');
    root.querySelector('[data-open-filters]')?.addEventListener('click', () => dialog?.showModal());
    root.querySelector('[data-close-filters]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    const toolbarFacets = [...root.querySelectorAll('.nl-facets--top .nl-facet')];
    toolbarFacets.forEach((facet) => facet.addEventListener('toggle', () => {
      if (!facet.open) return;
      toolbarFacets.forEach((other) => { if (other !== facet) other.open = false; });
    }));
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.nl-facets--top')) toolbarFacets.forEach((facet) => { facet.open = false; });
    });

    root.querySelectorAll('[data-facet-form]').forEach((form) => {
      let timer;
      form.addEventListener('change', () => {
        if (form.closest('[data-filter-dialog]')) return;
        clearTimeout(timer);
        timer = setTimeout(() => form.submit(), 250);
      });
    });

    root.querySelectorAll('[data-facet-toggle]').forEach((button) => button.addEventListener('click', () => {
      const body = button.closest('.nl-facet__body');
      const expanded = body?.classList.toggle('is-expanded') || false;
      button.setAttribute('aria-expanded', String(expanded));
      const labels = button.querySelectorAll('span');
      if (labels[0]) labels[0].hidden = expanded;
      if (labels[1]) labels[1].hidden = !expanded;
    }));

    root.querySelector('[data-collection-sort]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    });
  };
  const run = () => document.querySelectorAll('[data-netline-collection]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
})();
